// 2020-06-27export { SplashScreenComponent } from './splash-screen.component';